import classNames from "classnames/dedupe";
import React, { FC, ReactNode } from "react";

export type TFilterFormItemWrapperType =
  | "radio"
  | "tile"
  | "checkbox"
  | "search";

export interface IFilterFormItemWrapperProps {
  /**
   * Type of wrapper component, sets the correct css classes
   *
   *  @type {('radio'|'tile'|'checkbox'|'search')}
   */
  type: TFilterFormItemWrapperType;
  classes?: { root?: string };
  children?: ReactNode;
  onClick?(): void;
}

const typeMapping: Record<TFilterFormItemWrapperType, string> = {
  radio: "filter-form-item--radio",
  tile: "filter-form-item--tile",
  checkbox: "filter-form-item--checkbox",
  search: "filter-form-item--search",
};

const FilterFormItemWrapper: FC<IFilterFormItemWrapperProps> = ({
  type,
  classes,
  children,
  onClick,
}) => {
  const rootClasses = classNames(
    "filter-form-item",
    typeMapping[type],
    classes?.root,
  );

  return (
    <div className={rootClasses} onClick={onClick}>
      {children}
    </div>
  );
};

export default FilterFormItemWrapper;
